import close_icon_gray from 'src/assets/close_icon_gray.png';

import dayjs from 'dayjs'
import { useContext, useEffect, useState } from 'react'
import { CongratulatoryCardContext } from 'src/consumer/context/CongraulatoryCardContext'
import { getBodyForSavingJournal } from 'src/consumer/helpers/dailyPlayHelper'
import { saveJournal } from 'src/consumer/services/featureServices'
import { GenericModal } from '../JournalComponents'
import {
  AllTextContainer,
  AnswerContainer,
  AnswerTextArea,
  BackText,
  HintTextContainer,
  HintsContainer,
  NewEntryBackContainer,
  NewEntryNav,
  NewEntryNavButton,
  PrePostMsgContainer,
  ProgressBarContainer,
  ProgressBarFilled,
  QuestionAnsContainer,
  QuestionContainer,
  ScreenBackground,
  StyledUnderline,
  SubmitArrow,
  SubmitButton,
  SubtextContainer,
} from '../JournalStyles'
import { newJournalAfterSubmitLogic } from './journal_utils'

export function NewJournalPageForPublicPage({
  setParentModalState,
  newEntryData,
  toggleModal,
  afterSubmitFunction,
}) {
  const [pageNumber, setPageNumber] = useState(0)
  const [quesAns, setQuesAns] = useState(newEntryData?.journalQusAns)
  const [pageState, setPageState] = useState('journaling')
  const [closeWarningVisible, setCloseWarningVisible] = useState(false)
  let startingTime = dayjs()
  const [congratulatoryCardData, setCongratulatoryCardData] = useState()

  const [submitWaiting, setSubmitWaiting] = useState(false) // use this later

  let preMsgs = newEntryData?.preMsgs || []
  let postMsgs = newEntryData?.postMsgs || []
  let messagesInOrder = []

  preMsgs?.forEach((item) => {
    messagesInOrder.push({ id: 'preMsg', data: item })
  })
  quesAns?.forEach((item) => {
    messagesInOrder.push({ id: 'quesAns', data: item })
  })
  postMsgs?.forEach((item) => {
    messagesInOrder.push({ id: 'postMsg', data: item })
  })
  function handleAnswerChange(index, answer) {
    const temp = [...quesAns]
    temp[index].answere = answer
    temp[index].answer = answer
    setQuesAns(temp)
  }
  function handleHintAddition(index, hintText) {
    const temp = [...quesAns]
    temp[index].answere += ` ${hintText} `
    temp[index].answer += ` ${hintText} `
    setQuesAns(temp)
  }
  function handleClose() {
    setCloseWarningVisible(true)
  }

  async function handleSubmit() {
    console.log({ srcName: newEntryData?.sourceName })

    if (pageState === 'endscreen') {
      await newJournalAfterSubmitLogic(
        newEntryData,
        setCongratulatoryCardData,
        toggleModal,
        afterSubmitFunction,
        setParentModalState,
        setPageState,
      )
    } else if (pageNumber === messagesInOrder?.length - 1) {
      setSubmitWaiting(true)
      let timeOnSubmit = dayjs()
      let duration = timeOnSubmit.diff(startingTime, 'milliseconds')
      const body = getBodyForSavingJournal(
        newEntryData?.id,
        quesAns,
        newEntryData?.journalType,
        startingTime,
        duration,
        newEntryData?.jetID || '',
      )
      const response = await saveJournal(
        newEntryData?.id,
        body,
        newEntryData?.sourceName,
        newEntryData?.callSourceId,
      )

      if (response.status === 200) {
        setSubmitWaiting(false)
        await newJournalAfterSubmitLogic(
          newEntryData,
          setCongratulatoryCardData,
          toggleModal,
          afterSubmitFunction,
          setParentModalState,
          setPageState,
        )
      }
    } else {
      setPageNumber((prev) => prev + 1)
    }
  }

  useEffect(() => {
    console.log({ newEntryData })
  }, [newEntryData])

  return (
    <>
      <ScreenBackground newEntry>
        <NewEntryNav>
          <NewEntryBackContainer
            onClick={() => setPageNumber((prev) => prev - 1)}
            hide={pageNumber === 0}
          >
            {pageState === 'journaling' && (
              <>
                <BackText>Go back</BackText>
                <StyledUnderline />
              </>
            )}
          </NewEntryBackContainer>

          {messagesInOrder?.[pageNumber]?.id === 'quesAns' &&
            pageNumber + 1 - preMsgs?.length !== 1 && (
              <ProgressBarContainer className="progress">
                <ProgressBarFilled
                  className="progress-bar"
                  role="progressbar"
                  style={{
                    width: `${(100 * (pageNumber + 1 - preMsgs?.length)) / quesAns?.length}%`,
                  }}
                >
                  {`${pageNumber + 1 - preMsgs?.length} of ${quesAns?.length}`}
                </ProgressBarFilled>
              </ProgressBarContainer>
            )}

          <NewEntryNavButton
            src={close_icon_gray}
            onClick={handleClose}
          />
        </NewEntryNav>

        {pageState === 'journaling' && (
          <>
            {(messagesInOrder?.[pageNumber]?.id === 'preMsg' ||
              messagesInOrder?.[pageNumber]?.id === 'postMsg') && (
              <>
                <PrePostMsgContainer>
                  {messagesInOrder?.[pageNumber]?.data?.msg}
                </PrePostMsgContainer>

                <SubmitButton disabled={submitWaiting} onClick={handleSubmit}>
                  {pageNumber === messagesInOrder?.length - 1 ? 'Submit' : 'Next'}
                </SubmitButton>
              </>
            )}

            {messagesInOrder?.[pageNumber]?.id === 'quesAns' && (
              <QuestionAnsContainer>
                <AllTextContainer>
                  <QuestionContainer>
                    {messagesInOrder?.[pageNumber]?.data?.question}
                  </QuestionContainer>

                  <SubtextContainer>
                    {messagesInOrder?.[pageNumber]?.data?.subtext}
                  </SubtextContainer>

                  <HintsContainer>
                    {messagesInOrder?.[pageNumber]?.data?.hints &&
                      messagesInOrder?.[pageNumber]?.data?.hints?.length !== 0 &&
                      'Tips:'}
                    {messagesInOrder?.[pageNumber]?.data?.hints?.map((item, index) => {
                      return (
                        <HintTextContainer
                          key={index}
                          onClick={() => handleHintAddition(pageNumber - preMsgs?.length, item)}
                        >
                          {item}
                        </HintTextContainer>
                      )
                    })}
                  </HintsContainer>
                </AllTextContainer>

                <AnswerContainer>
                  <SubmitArrow
                    disabled={
                      submitWaiting ||
                      quesAns?.[pageNumber - preMsgs?.length]?.answere?.length === 0
                    }
                    onClick={handleSubmit}
                  />

                  <AnswerTextArea
                    autoFocus
                    placeholder="Your thoughts here.."
                    value={quesAns?.[pageNumber - preMsgs?.length]?.answere || ''}
                    onChange={(e) =>
                      handleAnswerChange(pageNumber - preMsgs?.length, e.target.value)
                    }
                  />
                </AnswerContainer>
              </QuestionAnsContainer>
            )}
          </>
        )}

        {pageState === 'endscreen' && (
          <>
            <PrePostMsgContainer>{newEntryData?.endScreen?.message}</PrePostMsgContainer>

            <SubmitButton onClick={handleSubmit}>
              {newEntryData?.endScreen?.buttonText}
            </SubmitButton>
          </>
        )}

        <GenericModal
          warning="Warning"
          warningDesc="You will lose all unsaved data"
          yes="I understand"
          onYes={() => {
            setCloseWarningVisible(false)
            if (newEntryData?.sourceName === 'daily-play' || newEntryData?.sourceName === 'tile') {
              afterSubmitFunction ? afterSubmitFunction(toggleModal) : toggleModal()
            } else {
              afterSubmitFunction
                ? afterSubmitFunction(toggleModal)
                : setParentModalState('user_journals')
            }
          }}
          no="Cancel"
          isOpen={closeWarningVisible}
          toggleFunc={() => setCloseWarningVisible((prev) => !prev)}
        />
      </ScreenBackground>
    </>
  )
}

export default function NewJournal({
  setParentModalState,
  newEntryData,
  toggleModal,
  afterSubmitFunction,
  ...props
}) {
  const [pageNumber, setPageNumber] = useState(0)
  const [quesAns, setQuesAns] = useState(newEntryData?.journalQusAns)
  const [pageState, setPageState] = useState('journaling')
  const [closeWarningVisible, setCloseWarningVisible] = useState(false)
  const { congratulatoryCardData, setCongratulatoryCardData } =
    useContext(CongratulatoryCardContext)
  let startingTime = dayjs()

  const [submitWaiting, setSubmitWaiting] = useState(false) // use this later

  let preMsgs = newEntryData?.preMsgs || []
  let postMsgs = newEntryData?.postMsgs || []
  let messagesInOrder = []

  preMsgs?.forEach((item) => {
    messagesInOrder.push({ id: 'preMsg', data: item })
  })
  quesAns?.forEach((item) => {
    messagesInOrder.push({ id: 'quesAns', data: item })
  })
  postMsgs?.forEach((item) => {
    messagesInOrder.push({ id: 'postMsg', data: item })
  })
  function handleAnswerChange(index, answer) {
    const temp = [...quesAns]
    temp[index].answere = answer
    temp[index].answer = answer
    setQuesAns(temp)
  }
  function handleHintAddition(index, hintText) {
    const temp = [...quesAns]
    temp[index].answere += ` ${hintText} `
    temp[index].answer += ` ${hintText} `
    setQuesAns(temp)
  }
  function handleClose() {
    setCloseWarningVisible(true)
  }

  async function handleSubmit() {
    console.log({ srcName: newEntryData?.sourceName })

    if (pageState === 'endscreen') {
      await newJournalAfterSubmitLogic(
        newEntryData,
        setCongratulatoryCardData,
        toggleModal,
        afterSubmitFunction,
        setParentModalState,
        setPageState,
      )
    } else if (pageNumber === messagesInOrder?.length - 1) {
      setSubmitWaiting(true)
      let timeOnSubmit = dayjs()
      let duration = timeOnSubmit.diff(startingTime, 'milliseconds')
      const body = getBodyForSavingJournal(
        newEntryData?.id,
        quesAns,
        newEntryData?.journalType,
        startingTime,
        duration,
        newEntryData?.jetID || '',
      )
      const response = await saveJournal(
        newEntryData?.id,
        body,
        newEntryData?.sourceName,
        newEntryData?.callSourceId,
      )

      if (response.status === 200) {
        setSubmitWaiting(false)
        await newJournalAfterSubmitLogic(
          newEntryData,
          setCongratulatoryCardData,
          toggleModal,
          afterSubmitFunction,
          setParentModalState,
          setPageState,
        )
      }
    } else {
      setPageNumber((prev) => prev + 1)
    }
  }

  return (
    <>
      <ScreenBackground newEntry>
        <NewEntryNav>
          <NewEntryBackContainer
            onClick={() => setPageNumber((prev) => prev - 1)}
            hide={pageNumber === 0}
          >
            {pageState === 'journaling' && (
              <>
                <BackText>Go back</BackText>
                <StyledUnderline />
              </>
            )}
          </NewEntryBackContainer>

          {messagesInOrder?.[pageNumber]?.id === 'quesAns' &&
            pageNumber + 1 - preMsgs?.length !== 1 && (
              <ProgressBarContainer className="progress">
                <ProgressBarFilled
                  className="progress-bar"
                  role="progressbar"
                  style={{
                    width: `${(100 * (pageNumber + 1 - preMsgs?.length)) / quesAns?.length}%`,
                  }}
                >
                  {`${pageNumber + 1 - preMsgs?.length} of ${quesAns?.length}`}
                </ProgressBarFilled>
              </ProgressBarContainer>
            )}

          <NewEntryNavButton
            src={close_icon_gray}
            onClick={handleClose}
          />
        </NewEntryNav>

        {pageState === 'journaling' && (
          <>
            {(messagesInOrder?.[pageNumber]?.id === 'preMsg' ||
              messagesInOrder?.[pageNumber]?.id === 'postMsg') && (
              <>
                <PrePostMsgContainer>
                  {messagesInOrder?.[pageNumber]?.data?.msg}
                </PrePostMsgContainer>

                <SubmitButton disabled={submitWaiting} onClick={handleSubmit}>
                  {pageNumber === messagesInOrder?.length - 1 ? 'Submit' : 'Next'}
                </SubmitButton>
              </>
            )}

            {messagesInOrder?.[pageNumber]?.id === 'quesAns' && (
              <QuestionAnsContainer>
                <AllTextContainer>
                  <QuestionContainer>
                    {messagesInOrder?.[pageNumber]?.data?.question}
                  </QuestionContainer>

                  <SubtextContainer>
                    {messagesInOrder?.[pageNumber]?.data?.subtext}
                  </SubtextContainer>

                  <HintsContainer>
                    {messagesInOrder?.[pageNumber]?.data?.hints &&
                      messagesInOrder?.[pageNumber]?.data?.hints?.length !== 0 &&
                      'Tips:'}
                    {messagesInOrder?.[pageNumber]?.data?.hints?.map((item, index) => {
                      return (
                        <HintTextContainer
                          key={index}
                          onClick={() => handleHintAddition(pageNumber - preMsgs?.length, item)}
                        >
                          {item}
                        </HintTextContainer>
                      )
                    })}
                  </HintsContainer>
                </AllTextContainer>

                <AnswerContainer>
                  <SubmitArrow
                    disabled={
                      submitWaiting ||
                      quesAns?.[pageNumber - preMsgs?.length]?.answere?.length === 0
                    }
                    onClick={handleSubmit}
                  />

                  <AnswerTextArea
                    autoFocus
                    placeholder="Your thoughts here.."
                    value={quesAns?.[pageNumber - preMsgs?.length]?.answere || ''}
                    onChange={(e) =>
                      handleAnswerChange(pageNumber - preMsgs?.length, e.target.value)
                    }
                  />
                </AnswerContainer>
              </QuestionAnsContainer>
            )}
          </>
        )}

        {pageState === 'endscreen' && (
          <>
            <PrePostMsgContainer>{newEntryData?.endScreen?.message}</PrePostMsgContainer>

            <SubmitButton onClick={handleSubmit}>
              {newEntryData?.endScreen?.buttonText}
            </SubmitButton>
          </>
        )}

        <GenericModal
          warning="Warning"
          warningDesc="You will lose all unsaved data"
          yes="I understand"
          onYes={() => {
            setCloseWarningVisible(false)
            if (newEntryData?.sourceName === 'daily-play' || newEntryData?.sourceName === 'tile') {
              afterSubmitFunction ? afterSubmitFunction(toggleModal) : toggleModal()
            } else {
              afterSubmitFunction
                ? afterSubmitFunction(toggleModal)
                : setParentModalState('user_journals')
            }
          }}
          no="Cancel"
          isOpen={closeWarningVisible}
          toggleFunc={() => setCloseWarningVisible((prev) => !prev)}
        />
      </ScreenBackground>
    </>
  )
}
